import { GlobalAxios } from "./../axios/axios-config";
import { IInsuranceRegister } from "../models/insurance-register";
import {
  INewTicketAutomationReceivedConfFile,
  ITicketAutomationReceivedConfFile,
} from "../models/ticket-automation-received-conf-files";

const TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedConfFiles/";

const INSURANCE_REGISTER_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/InsuranceRegister/CalendarRegister";

export const createTicketAutomationReceivedConfFile = (
  item: INewTicketAutomationReceivedConfFile
) => {
  return GlobalAxios.post(
    TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE,
    item
  );
};

export const getTicketAutomationReceivedConfFileById = (id: string) => {
  return GlobalAxios.get<ITicketAutomationReceivedConfFile>(
    TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE + id
  );
};

export const updateTicketAutomationReceivedConfFileById = ({
  item,
  id,
}: {
  item: INewTicketAutomationReceivedConfFile;
  id: string;
}) => {
  return GlobalAxios.put(
    TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE + id,
    item
  );
};

export const insuranceRegisterList = (params?: any) => {
  return GlobalAxios.get<IInsuranceRegister[]>(INSURANCE_REGISTER_ROUTE, {
    params: params,
    paramsSerializer: {
      indexes: null,
    },
  });
};
